import { forwardRef } from "react";
import PropTypes from "prop-types";
import { BellOutline } from "../../lib/SvgComponents.jsx";

const CollapsedView = forwardRef(
  (
    { expandNotification, label },
    { collapsedWrapperRef, collapsedBannerRef },
  ) => {
    return (
      <div
        ref={collapsedWrapperRef}
        className={`notification-banner-wrapper collapsed-view`}
        onClick={expandNotification}
      >
        <button
          ref={collapsedBannerRef}
          className={`notification-banner-label`}
        >
          {label}
          <span className="bell-icon">
            <svg aria-hidden="true" focusable="false">
              <BellOutline />
            </svg>
          </span>
        </button>
      </div>
    );
  },
);

CollapsedView.displayName = "CollapsedView";

CollapsedView.propTypes = {
  expandNotification: PropTypes.func,
  label: PropTypes.string,
};

export default CollapsedView;
